import * as types from '../actions/types';
import { actionTypes } from './reducerTypes';

const getInitialAppraisalSessionState = () => ({
  appraisalSearchHistory: [],
  appraisalSearchHistoryError: '',
  appraisalDetails: {},
  appraisalLoading: false,
  appraisalError: '',
  appraisalAllowance: {
    limit: 1,
    used: 0,
    remaining: 1,
    unlimited: false,
    canAppraise: true,
    resetAt: '',
  },
  appraisalAllowanceError: false,
  appraisalAllowanceLoading: false,
  todayAppraisalLimit: 0,
  alternateDomains: [],
  downloadingCertificate: false,
  loaderAlternateDomains: false,
});

let initialState = {
  exhibitBList: [],
  appraisalLimit: {
    appraisalLimitWithLogin: 5,
    appraisalLimitWithoutLogin: 1,
  },
  ...getInitialAppraisalSessionState(),
};

const appraisalReducer = (state = initialState, action: actionTypes) => {
  switch (action.type) {
    case types.RESET_APPRAISAL_SESSION:
      return {
        ...state,
        ...getInitialAppraisalSessionState(),
      };
    case types.ALTERNATES_LOADING:
      return {
        ...state,
        loaderAlternateDomains: action.payload,
      };
    case types.APPRAISAL_CERTIFICATE_DOWNLOADING:
      return {
        ...state,
        downloadingCertificate: action.payload,
      };
    case types.ALTERNATE_DOMAINS:
      return {
        ...state,
        loaderAlternateDomains: false,
        alternateDomains: action.payload,
      };
    case types.APPRAISAL_LIMIT_COUNT:
      return {
        ...state,
        appraisalLimit: action.payload,
      };
    case types.APPRAISAL_ALLOWANCE:
      return {
        ...state,
        appraisalAllowance: action.payload,
        appraisalAllowanceError: false,
        appraisalAllowanceLoading: false,
      };
    case types.APPRAISAL_ALLOWANCE_ERROR:
      return {
        ...state,
        appraisalAllowanceError: true,
        appraisalAllowanceLoading: false,
      };
    case types.APPRAISAL_ALLOWANCE_LOADING:
      return {
        ...state,
        appraisalAllowanceLoading: action.payload,
      };
    case types.TODAY_APPRAISAL_LIMIT_COUNT:
      return {
        ...state,
        todayAppraisalLimit: action.payload,
      };

    case types.APPRAISAL_LOADING:
      return {
        ...state,
        appraisalLoading: action.payload,
        appraisalError: action.payload ? '' : state.appraisalError,
      };

    case types.APPRAISAL_DETAIL:
      return {
        ...state,
        alternateDomains: [],
        appraisalError: '',
        appraisalDetails: action.payload,
      };
    case types.APPRAISAL_SEARCH_HISTORY:
      return {
        ...state,
        appraisalSearchHistory: action.payload,
        appraisalSearchHistoryError: '',
      };
    case types.APPRAISAL_SEARCH_HISTORY_ERROR:
      return {
        ...state,
        appraisalSearchHistoryError: action.payload,
        appraisalSearchHistory: [],
      };
    case types.APPRAISAL_ERROR:
      return {
        ...state,
        appraisalError: action.payload,
        appraisalLoading: false,
        appraisalDetails: {},
      };

    default:
      return state;
  }
};

export default appraisalReducer;
